module.exports = __webpack_public_path__ + "img/brand-idshop.21e3d852.svg";